export default "__VITE_ASSET__8baAJ274__"